// eslint-disable-next-line import/prefer-default-export
export const msgs = { pam: { landingPage: { hideSessions: 'Hide Sessions' } } };
